import React from 'react';
import SideBar from '../../navigation/sidebar.js';
import { AppLayout } from '@amzn/awsui-components-react-v3';
import SchedulesTable from './table/table.js';
import AppContext from "../../context/AppContext";
import { getSidebarItemFromPageStage } from "../home/home";
import ActivationRequired from "../../components/ActivationRequired";

class Schedules extends React.Component {
    static contextType = AppContext;
    render() {
        return (
            <AppLayout
                content={<ActivationRequired userStatus={this.context && this.context.userStatus}><SchedulesTable /></ActivationRequired>}
                navigation={<SideBar activeHref="/schedules" items={getSidebarItemFromPageStage(this.context.pageStage)} />}
                navigationOpen={true}
                onNavigationChange={() => {}}
                toolsHide={true}
            />
        );
    }
}

export default Schedules;